import {
    fetchNotificationsByType,
    fetchEmailSummarySubscribers,
    updateItemEmailFrequency,
} from '@/vuex/modules/notifications/notifications.utils.js';
import { getAllNpsThemes } from '@/net-promoter-system/nps-responses-table/utils';
import { EMAIL_FREQUENCY, emailSummarySettings } from '@/net-promoter-system/constants/nps.constants';

const { targetType, notificationType } = emailSummarySettings;

const nps = {
    namespaced: true,
    state: {
        activeNpsId: '',
        emailNotificationsNpsIds: [],
        emailNotificationsSubscribedUsers: [],
        emailNotificationsFrequency: EMAIL_FREQUENCY.MONTHLY,
        error: {},
        aiActivityResponsesFromAgg: [],
        aiActivityAggStatus: null,
        npsDeletedThemes: [],
    },
    mutations: {
        setActiveNpsId (state, { id }) {
            state.activeNpsId = id;
        },
        setEmailNotificationsNpsIds (state, notifications) {
            state.emailNotificationsNpsIds = notifications ? [...notifications] : [];
        },
        setEmailNotificationsSubscribedUsers (state, { subscribedUsers }) {
            state.emailNotificationsSubscribedUsers = subscribedUsers;
        },
        setEmailNotificationsFrequency (state, { frequency }) {
            state.emailNotificationsFrequency = frequency;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setAiActivityAggStatus (state, { status }) {
            state.aiActivityAggStatus = status;
        },
        setAiActivityResponsesFromAgg (state, { responses }) {
            state.aiActivityResponsesFromAgg = responses;
        },
        setNpsDeletedThemes (state, { deletedThemes }) {
            state.npsDeletedThemes = deletedThemes;
        },
    },
    actions: {
        async getEmailSummaryNotifications ({ commit }) {
            try {
                const npsIds = await fetchNotificationsByType(notificationType);
                commit('setEmailNotificationsNpsIds', npsIds);
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async getEmailSummarySubscribedUsers ({ commit }, { guideId }) {
            try {
                const { users, frequency } = await fetchEmailSummarySubscribers(notificationType, targetType, guideId);

                commit('setEmailNotificationsSubscribedUsers', { subscribedUsers: users });
                commit('setEmailNotificationsFrequency', {
                    frequency: frequency === EMAIL_FREQUENCY.WEEKLY ? EMAIL_FREQUENCY.WEEKLY : EMAIL_FREQUENCY.MONTHLY,
                });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async updateEmailSummaryFrequency ({ commit }, { guideId, frequency }) {
            try {
                await updateItemEmailFrequency(guideId, targetType, { emailFrequency: frequency });
                commit('setEmailNotificationsFrequency', { frequency });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async fetchGuideDeletedNpsThemes ({ commit }, { guideId }) {
            const deletedThemes = await getAllNpsThemes(guideId, true);
            commit('setNpsDeletedThemes', { deletedThemes });
        },
    },
    getters: {
        isSubscribed: (state) =>
            !!state.emailNotificationsNpsIds.length && state.emailNotificationsNpsIds.includes(state.activeNpsId),
        aiActivityResponses: ({ aiActivityResponsesFromAgg }) =>
            aiActivityResponsesFromAgg.filter((r) => typeof r.counts === 'undefined'),
        newlyAssignedResponses: (state, { aiActivityResponses }) =>
            aiActivityResponses.filter((r) => r.firstAssignedThemeByMlAt === r.lastUpdatedByMlAt),
        reAssignedResponses: (state, { aiActivityResponses }) =>
            aiActivityResponses.filter((r) => r.firstAssignedThemeByMlAt < r.lastUpdatedByMlAt),
    },
};

export default nps;
